<template>
    <div>
        <CRow class="content-fade-in">
            <CCol md="12">
                <CCard>
                    <CCardBody>
                        <CForm class="form-basic">
                            <CRow>
                                <CCol sm="12" md="6" xl="6">
                                    <BaseSelect :options="orgSelect.options" :data="orgSelect.data" ref="orgSelect">
                                    </BaseSelect>
                                </CCol>
                                <CCol sm="12" md="6" xl="6">
                                    <div class="form-group form-input-wrapper">
                                        <label>Đơn giá <span class='required'>*</span></label>
                                        <template>
                                            <currency-input class="form-control" v-model="priceInput.data.model"
                                                @blur="priceInput.data.validator.valid()" currency="VND" locale="vi" />
                                        </template>
                                        <div class="valid-error" v-show="!priceInput.data.validator.isValid">
                                            {{ priceInput.data.validator.errorMessage }}
                                        </div>
                                    </div>
                                </CCol>
                            </CRow>

                            <CRow>
                                <CCol sm="12" md="6" xl="6">
                                    <BaseInput :options="maxDeviceInput.options" :data="maxDeviceInput.data" />
                                </CCol>
                                <CCol sm="12" md="6" xl="6">
                                    <div class="form-group">
                                        <label for="datepicker">Ngày bắt đầu - Ngày kết thúc <span class='required'>*</span></label>
                                        <DatePicker id="datepicker" v-model="dateRange"
                                            :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" is-range
                                            class="datepicker">
                                            <template v-slot="{ inputValue, inputEvents }">
                                                <input :value="inputValue.start + ' - ' + inputValue.end"
                                                    v-on="inputEvents.start"
                                                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                                                    readonly />
                                            </template>
                                        </DatePicker>
                                    </div>
                                </CCol>
                            </CRow>


                            <CRow>
                                <CCol sm="12" md="12" xl="12">
                                    <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data" />
                                </CCol>
                            </CRow>
                            <div slot="footer" class="mt-4">
                                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData">
                                    <i class="fa fa-plus"></i> Thêm mới
                                </CButton>
                                <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i
                                        class="fa fa-reply"></i> Hủy bỏ
                                </CButton>
                            </div>
                            <BaseLoading :loading="loading.value"></BaseLoading>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea";
import {DatePicker} from "v-calendar";

export default {
    name: "LicenseAdd",
    components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea, DatePicker},
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Errors"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    data: function () {
        let that = this;
        return {
            loading: { value: false },
            dateRange: {
                start: new Date(),
                end: new Date()
            },
            orgSelect: {
                options: {
                    label: "Đơn vị <span class='required'>*</span>",
                    selectAllText: "Chọn đơn vị",
                    filter: true,
                    keyField: "value",
                    valueField: "text",
                },
                data: {
                    model: "",
                    name: "orgId",
                    source: {
                        url: "/organization/list-org-active",
                        response: function (dataResponse) {
                            return dataResponse.data;
                        },
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.orgSelect.data.model;
                            if (value === "") {
                                this.isValid = false;
                                this.errorMessage = "Đơn vị không được để trống";
                            } else {
                                this.isValid = true;
                                this.errorMessage = "";
                            }
                            return this.isValid;
                        },
                    },
                },
            },
            priceInput: {
                options: {
                    label: "Đơn giá <span class='required'>*</span>",
                    placehder: "Đơn giá",
                    type: "text",
                },
                data: {
                    name: "cost",
                    model: 0,
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.priceInput.data.model;
                            if (value === "" || value === null || value == 0) {
                                this.isValid = false;
                                this.errorMessage = "Đơn giá không được để trống";
                            } else {
                                this.isValid = true;
                                this.errorMessage = "";
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            maxDeviceInput: {
                options: {
                    label: "Số lượng thiết bị <span class='required'>*</span>",
                    placeholder: "Số lượng thiết bị",
                    type: "number"
                },
                data: {
                    name: "maxDevice",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.maxDeviceInput.data.model;
                            if (value === "" || value === null || value == 0) {
                                this.isValid = false;
                                this.errorMessage = "Số lượng thiết bị không được để trống";
                            } else {
                                this.isValid = true;
                                this.errorMessage = "";
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            descriptionInput: {
                options: {
                    label: "Mô tả <span class='required'>*</span>",
                    placeholder: "Mô tả",
                    maxlength: 256
                },
                data: {
                    name: "description",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.descriptionInput.data.model;
                            if (value === "") {
                                this.isValid = false;
                                this.errorMessage = "Mô tả không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            }
        }
    },
    methods: {
        submitData: function () {
            let that = this;
            this.$helper.loadDataSource({
                loading: that.loading,
                url: "/license/add",
                dataSubmit: function () {
                    var data = that.$helper.setupDataSubmit(that.$data);
                    data.startDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start.getTime());
                    data.endDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end.getTime());
                    return data;
                },
                successCallback: function (response) {
                    if (!that.$helper.validResponse(that.$router, response.data)) {
                        that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
                        that.$helper.setupErrorModel(response.data.data, that.$data);
                    } else {
                        that.showSuccessMsg({
                            message: "Thêm mới license thành công"
                        });
                        that.$router.go(-1);
                    }
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });
        },

    },
    computed: {},
    created() {
    },
    mounted() {

    },
    watch: {}
};
</script>
